import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Button,
  message,
  Divider,
  Table,
  Input,
  Tooltip,
  Form,
  Modal,
  Select,
  Space,
  InputNumber,
} from "antd";
import { EditOutlined, SearchOutlined, PlusOutlined, DeleteOutlined, ColumnHeightOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate } from "react-router-dom";
import http from "../../../services/http";
const { Text } = Typography;

// STATUS
const options_status = [
  { value: 0, label: "Inativo" },
  { value: 1, label: "Ativo" },
];

export const UniformesCadTamanhos = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();

  // ID ALTERAÇÃO
  const [idAlt, setIdAlt] = useState(0);
  const [search, setSearch] = useState("");

  useEffect(() => {
    listarTamanhos();
  }, []);

  // LISTAR
  const listarTamanhos = async () => {
    setLoading(true);
    const api = await http("get", `v1/uniformes_tamanhos/listar`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CADASTRAR
  const cadastrarTamanho = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/uniformes_tamanhos/adicionar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro cadastrado com sucesso!");
      setShowModal(false);
      resetForm();
      listarTamanhos();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // ALTERAR
  const alterarTamanho = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/uniformes_tamanhos/alterar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro alterado com sucesso!");
      setShowModal(false);
      resetForm();
      listarTamanhos();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR
  const carregarTamanho = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/uniformes_tamanhos/carregar/${id}`, []);

    if (api.statusCode === 200) {
      setShowModal(true);
      resetForm();
      form.setFieldsValue({
        descricao: api.response.data.descricao,
        ordem: api.response.data.ordem,
        status: api.response.data.status,
      });
      setIdAlt(api.response.data.id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // DELETAR
  const deletarTamanho = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/uniformes_tamanhos/deletar`, { id: id });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      listarTamanhos();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RESET FORM
  const resetForm = () => {
    form.resetFields();
    setIdAlt(0);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Descrição",
      dataIndex: "descricao",
      sorter: (a, b) => a.descricao?.localeCompare(b.descricao),
    },
    {
      title: "Ordem",
      dataIndex: "ordem",
      sorter: (a, b) => a.ordem?.toString()?.localeCompare(b.ordem?.toString()),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (_, e) => (e.status === 1 ? "Ativo" : "Inativo"),
      sorter: (a, b) => (a.status === 1 ? "Ativo" : "Inativo")?.localeCompare(b.status === 1 ? "Ativo" : "Inativo"),
    },
    {
      title: "Ações",
      width: 150,
      render: (_, e) => (
        <Space.Compact>
          <Tooltip title="Editar">
            <Button loading={loading} onClick={() => carregarTamanho(e.id)} icon={<EditOutlined />} />
          </Tooltip>
          <Tooltip title="Excluir">
            <Button
              loading={loading}
              icon={<DeleteOutlined />}
              onClick={() => {
                modal.confirm({
                  title: "Deseja deletar este registro?",
                  okText: "Sim",
                  cancelText: "Cancelar",
                  onOk() {
                    deletarTamanho(e.id);
                  },
                });
              }}
            />
          </Tooltip>
        </Space.Compact>
      ),
      dataIndex: "acoes",
    },
  ];

  // SUBMIT FORM
  const onSubmit = (formulario) => {
    if (idAlt > 0) {
      formulario.id = idAlt;
      alterarTamanho(formulario);
    } else {
      cadastrarTamanho(formulario);
    }
  };

  // PESQUISAR
  const handleFilter = (pesquisar) => {
    let filteredData = dados?.filter(
      (val) =>
        val.descricao?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.ordem?.toString()?.toLowerCase().includes(pesquisar.toLowerCase())
    );

    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search) : [];

  // FORMULÁRIO
  const modalFormulario = () => {
    return (
      <Modal
        title={
          <Text style={{ fontSize: 20 }}>
            <EditOutlined /> {idAlt > 0 ? "Editar" : "Adicionar"} Tamanho
          </Text>
        }
        open={showModal}
        onOk={() => form.submit()}
        okText="Salvar"
        width={1200}
        okButtonProps={{ size: "large", loading: loading }}
        cancelButtonProps={{ size: "large", loading: loading }}
        onCancel={() => {
          setShowModal(false);
          resetForm();
        }}>
        <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="descricao"
                label="Descrição"
                rules={[{ required: true, message: "Digite a descrição!" }]}>
                <Input size="large" disabled={loading} placeholder="Informe a descrição" />
              </Form.Item>
            </Col>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="ordem"
                label="Ordem de Exibição"
                rules={[{ required: true, message: "Digite a ordem!" }]}>
                <InputNumber
                  min={1}
                  size="large"
                  precision={0}
                  disabled={loading}
                  placeholder="Informe a ordem"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="status" label="Status" rules={[{ required: true, message: "Selecione o status!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione o status"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={options_status}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario()}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Uniformes" onClickBack={() => navigate("/")} />
            <HeaderTitle
              title="Uniformes Tamanhos"
              subtitle="Cadastro de Tamanhos"
              icon={<ColumnHeightOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space wrap>
                <Input
                  size="middle"
                  maxLength={100}
                  prefix={<SearchOutlined />}
                  className="input"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Pesquisar..."
                  allowClear
                />
                <Tooltip title="Adicionar Registro">
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => {
                      setShowModal(true);
                      resetForm();
                    }}
                    loading={loading}>
                    Novo
                  </Button>
                </Tooltip>
              </Space>

              <Divider />

              <Table
                rowKey="id"
                loading={loading}
                scroll={{ x: 700 }}
                columns={columns}
                dataSource={dadosFilter}
                size="small"
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
